<template>
  <section id="confirm-activation-code-section" class="section-scc-portal container">
    <form id="form-confirm-activation-code-portal-scc">
      <div class="row container-item-form">
        <div class="container-input-form container-input-form-left col-sm">
          <label class="label-form-css" for="login-donor-portal-email">Enter activation code:</label>
          <input
              type="text"
              class="form-control input-form-css"
              id="login-donor-portal-email"
              aria-describedby="enterActivationCodeHelp"
              v-model.trim="confirmActivationCode"
          >
          <small id="enterActivationCode" class="form-text text-muted">Required field.</small>
        </div>
      </div>
      <div class="row container-item-form">
        <div class="col container-item-form" style="padding: 0;">
          <button
              type="button"
              class="button-section btn"
              @click="actionSignApp"
          >
            ACTIVATE
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
        <div class="col container-item-form" style="display: flex; justify-content: flex-end;">
          <button
              type="button"
              class="button-section btn"
              id="resend-code-confirm-activation-code"
              v-on:click="resendCode"
          >
            RESEND CODE
            <i class="fa fa-chevron-right" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </form>
  </section>
</template>
<script>

import moment from 'moment-timezone';
import { mapState } from 'vuex';
import md5 from 'md5';
import xlooLib from "@/librarys/xlooLib";

export default {
  name: "cnaEnterActivationCode",
  data(){
    return{
      confirmActivationCode: '',
      activationCode: '',
    }
  },
  computed : {
    ...mapState({
      createNewAccountData: state => state.auth.createNewAccountData,
    })
  },
  created() {
    this.activationCode = this.createNewAccountData
  },
  methods: {
    async actionSignApp() {
      const dataCheckActivationCode = {
        typeActions: 'check',
        check_activation_code: md5(this.confirmActivationCode),
        idDonor: this.$store.getters["auth/createNewAccountData"].idDonor,
        password_c: this.$store.getters["auth/createNewAccountData"].password,
        username_c: this.$store.getters["auth/createNewAccountData"].email,
        first_name: this.$store.getters["auth/createNewAccountData"].firstName,
        last_name: this.$store.getters["auth/createNewAccountData"].lastName,
        dob: moment(this.$store.getters["auth/createNewAccountData"].dob, "MM/DD/YYYY").format("YYYY-MM-DD"),
        phone_mobile: xlooLib.phoneCleaner(this.$store.getters["auth/createNewAccountData"].phoneMobile),
        sms_opted_out: this.$store.getters["auth/createNewAccountData"].smsOptedOut,
        noThread: 0,
      }
      this.$root.$emit("showSpinner")
      const response = await this.$store.dispatch('auth/SET_activationCodeRequest', dataCheckActivationCode)
      this.$root.$emit("hideSpinner")

      if(response.result.result){
        this.$router.push({ name: 'loginDonor' })
      } else {
        this.errorAlert('Activation code is incorrect!')
      }
    },
    resendCode(){
      this.$router.push({ name: 'cnaRequestActivationCode' })
    },
    errorAlert(message){
      this.$root.$emit('messageBox',
        {
          timeShow: 0,
          typeColor: "danger",
          textMessage: message,
        })
    },
  }
}
</script>

<style scoped>

</style>
